module.exports = __webpack_public_path__ + "static/img/6.155fa55d.png";